<template>
    <div class="row">
        <div class="col-12 mb-1">
            <div class="alert alert-primary mb-0">
                <div class="alert-body">
                    {{ value.FullName }} - {{ value.FileNumber }}
                </div>
            </div>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Yanıt Tarihi</label>
            <v-date-picker v-model="value.RejectDate" for-back type="datetime" placeholder="Yanıt Tarihi"></v-date-picker>
        </div>
        <div class="col-12">
            <label class="form-label">Açıklama</label>
            <textarea class="form-control resize-none" v-model="value.Description" placeholder="Açıklama" rows="3"></textarea>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object
    }
}
</script>

<style>

</style>